import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { addToast } from "../slices/toastSlice";
import { logoutUser } from "../slices/authSlice";

const rawBaseQuery = fetchBaseQuery({
  baseUrl: "/api",
  credentials: "include",
  prepareHeaders: (headers, { getState }) => {
    const token = (getState()).auth.token;
    const lang = localStorage.getItem('preferred-language')
    if (token) { 
      headers.set("Authorization", `Bearer ${token}`);
      headers.set("Accept-Language", `${lang}`);
    }
    return headers;
  },
});

const baseQuery = async (args, api, extra) => {
  const res = await rawBaseQuery(args, api, extra);
  const lang = localStorage.getItem('preferred-language');
  if (res.error?.status === 401) {
    (api.dispatch)(logoutUser())
  }
  if (res.error) {
    const err = res.error;
    const message =
      (typeof err.data === 'object' && err.data.detail) ||
      (typeof err.data === 'string' && err.data) ||
      (lang == 'en' ? `Request failed (${err.status})` : `(${err.status}) คำร้องของคุณล้มเหลว`);

    api.dispatch(addToast({
      id: Date.now().toString(),
      message,
      source: 'rtkQuery',
      code: typeof err.status === 'string' ? err.status : String(err.status),
      type: 'error'
    }));
  }
  return res;
};

export const api = createApi({
  reducerPath: "api",
  baseQuery,
  tagTypes: ["Users", "Customers", "Products", "Distributors", "Invoices", "Creditnotes", "SalesDocuments"],
  endpoints: () => ({}), 
});

/**
 * Builds a URL with query parameters from a params object.
 * @param {string} baseUrl - The base URL.
 * @param {object} params - The parameters object.
 * @returns {string} The full URL with query string.
 */
export const buildUrl = (baseUrl, params) => {
  if (!params) {
    return baseUrl;
  }
  const searchParams = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    if (value !== undefined && value !== null && value !== "" && !(Array.isArray(value) && value.length === 0)) {
      if (key === 'search' && typeof value === 'object') {
        for (const [searchKey, searchValue] of Object.entries(value)) {
           if (searchValue !== undefined && searchValue !== null && searchValue !== "" && searchValue !== "all") {
             searchParams.append(searchKey, String(searchValue));
           }
        }
      } else {
        searchParams.append(key, String(value));
      }
    }
  }
  return `${baseUrl}?${searchParams.toString()}`;
};